export enum TipoBootstrap {
  PRIMARY = "BS_PRIMARY",
  SECONDARY = "BS_SECONDARY",
  SUCCESS = "BS_SUCCESS",
  DANGER = "BS_DANGER",
  WARNING = "BS_WARNING",
  INFO = "BS_INFO"
}
